import { render } from "./Anagrafica.vue?vue&type=template&id=cd222a4a"
import script from "./Anagrafica.vue?vue&type=script&lang=js"
export * from "./Anagrafica.vue?vue&type=script&lang=js"
script.render = render

export default script